import { SVGProps } from 'react';

import { cn } from 'utils/cn';

export const CheckmarkIcon: React.FC<SVGProps<SVGSVGElement>> = props => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} className={cn('text-icn-txt-sec', props.className)}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.0169 4.59675C18.4074 4.98728 18.4074 5.62045 18.0168 6.01096L8.62381 15.4034C8.43626 15.5909 8.18188 15.6963 7.91665 15.6963C7.65142 15.6962 7.39706 15.5909 7.20954 15.4033L1.98328 10.1759C1.59279 9.78531 1.59286 9.15215 1.98343 8.76166C2.374 8.37118 3.00716 8.37125 3.39764 8.76182L7.91682 13.282L16.6026 4.5967C16.9932 4.20619 17.6263 4.20621 18.0169 4.59675Z"
      fill="currentColor"
    />
  </svg>
);
